module.exports = __webpack_public_path__ + "static/media/PM135.c3190531.png";